module.exports = {"141128100":"圪洞镇","141128101":"马坊镇","141128102":"峪口镇","141128103":"大武镇","141128104":"北武当镇","141128105":"积翠镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141128.json
// module id = 474
// module chunks = 0